const SearchIcon = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    className=""
  >
    <path
      className="fill-color"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10.5C7 8.567 8.567 7 10.5 7C12.433 7 14 8.567 14 10.5C14 12.433 12.433 14 10.5 14C8.567 14 7 12.433 7 10.5ZM10.5 4C6.91015 4 4 6.91015 4 10.5C4 14.0899 6.91015 17 10.5 17C11.7515 17 12.9204 16.6463 13.9121 16.0335L17.4393 19.5607C18.0251 20.1464 18.9749 20.1464 19.5607 19.5607C20.1464 18.9749 20.1464 18.0251 19.5607 17.4393L16.0335 13.9121C16.6463 12.9204 17 11.7515 17 10.5C17 6.91015 14.0899 4 10.5 4Z"
      fill="#00365e"
    />
  </svg>
);
export default SearchIcon;
